import React, { useState } from "react";
import Chart from "react-apexcharts";
import { Card } from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";
import { Dropdown } from "react-bootstrap";
export default function BacklogGrowth() {
  const [filter, setFilter] = useState("Monthly");
  const options = ["Today", "Weekly", "Monthly"];
  const dataMap = {
    Monthly: [80, 280, 330, 410, 470, 520, 560],
    Weekly: [50, 150, 200, 260, 300, 340, 380],
    Today: [30, 120, 180, 220, 260, 300, 340],
  };

  const categories = ["Mon","Tue","Wed","Thu","Fri","Sat","Sun"];
  const data = dataMap[filter];

  const max = 700;

  return (
    <Card className="backlog-card h-100">
      <Card.Body>

        {/* HEADER */}
        <div className="backlog-header">
          <h6 className="title">
            Backlog <span className="highlight">G</span>rowth
          </h6>

          <div className="dropdown-box">
            <FiCalendar />
            <Dropdown>
        <Dropdown.Toggle className="custom-toggle">
          {filter}
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {options.map((item) => (
            <Dropdown.Item
              key={item}
              active={filter === item}
              onClick={() => setFilter(item)}
              className="custom-item"
            >
              {item}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
          </div>
        </div>

        {/* CHART */}
        <Chart
          type="bar"
          height={300}
          series={[
            {
              name: "Growth",
              data,
            },
            {
              name: "Background",
              data: new Array(7).fill(max),
            },
          ]}
          options={{
            chart: {
              stacked: true,
              toolbar: { show: false },
            },

            colors: ["#184e56", "#e5e7eb"],

            plotOptions: {
              bar: {
                columnWidth: "65%", // 🔥 thickness
                borderRadius: 14,   // 🔥 rounded bars
              },
            },

            stroke: {
              show: true,
              width: [0, 2],
              colors: ["transparent", "#cbd5e1"],
              dashArray: [0, 6],
            },

            dataLabels: { enabled: false },

            xaxis: {
              categories,
              labels: {
                style: {
                  colors: "#6b7280",
                  fontSize: "13px",
                },
              },
              axisBorder: { show: false },
              axisTicks: { show: false },
            },

            yaxis: {
              max: max,
              labels: {
                style: {
                  colors: "#6b7280",
                },
              },
            },

            grid: {
              borderColor: "#f1f5f9",
              strokeDashArray: 0,
            },

            tooltip: {
              custom: function ({ series, seriesIndex, dataPointIndex }) {
                if (seriesIndex === 1) return "";

                const value = series[0][dataPointIndex];

                return `
                  <div style="
                    background:#e5e7eb;
                    border-radius:12px;
                    overflow:hidden;
                    box-shadow:0 8px 20px rgba(0,0,0,0.15);
                    font-size:13px;
                  ">
                    <div style="
                      padding:8px 12px;
                      border-bottom:1px solid #d1d5db;
                      color:#6b7280;
                    ">
                      ${categories[dataPointIndex]}
                    </div>

                    <div style="
                      padding:10px 12px;
                      display:flex;
                      align-items:center;
                      gap:6px;
                    ">
                      <span style="
                        width:10px;
                        height:10px;
                        background:#184e56;
                        border-radius:50%;
                        display:inline-block;
                      "></span>

                      Growth: <b>${value}</b>
                    </div>
                  </div>
                `;
              },
            },

            legend: { show: false },
          }}
        />

        {/* FOOTER */}
        <div className="growth-footer">
          <span className="dot"></span>
          12% Compared to Last Week
        </div>

      </Card.Body>

      {/* INTERNAL CSS */}
      <style>{`
        .backlog-card {
          border-radius: 5px;
          border: 2px solid #e5e7eb;
          padding: 12px;
        }

        .backlog-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;
          flex-wrap: wrap;
          gap: 10px;
        }

        .title {
          font-weight: 600;
          font-size: 16px;
        }

        .highlight {
          background: #f97316;
          color: #fff;
          padding: 0 4px;
          border-radius: 2px;
        }

        .dropdown-box {
          display: flex;
          align-items: center;
          gap: 6px;
          border: 1px solid #e5e7eb;
          padding: 6px 10px;
          border-radius: 8px;
          background: #fff;
        }

        .dropdown-box select {
          border: none;
          outline: none;
          font-size: 13px;
          background: transparent;
        }

        .growth-footer {
          margin-top: 14px;
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 6px;
          font-size: 13px;
        }

        .dot {
          width: 12px;
          height: 12px;
          background: #22c55e;
          border-radius: 50%;
        }
/* Remove default bootstrap button style */
.custom-toggle {
  background: transparent !important;
  border: none !important;
  color: #333;
  font-size: 14px;
 
  box-shadow: none !important;
  padding: 1px 1px;
}

/* Dropdown menu styling */
.dropdown-menu {
  border-radius: 10px;
  padding: 5px;
}

/* Default item */
.custom-item {
  border-radius: 8px;
  padding: 8px 8px;
}

/* Hover */
.custom-item:hover {
  background-color: #fff3e6;
  color: #ff8c00;
}

/* Active (Selected = ORANGE) */
.custom-item.active {
  background-color: #ff8c00 !important;
  color: #fff !important;
}

.dropdown-toggle::after {
  display: none !important;
}

        /* MOBILE */
        @media (max-width: 768px) {
          .title {
            font-size: 14px;
          }

          .dropdown-box {
            padding: 4px 8px;
          }
        }
      `}</style>
    </Card>
  );
}